import { CalendarDays, ClipboardCheck, Globe2, Home, UserRound } from 'lucide-react'

import { useLanguage } from '../shared/LanguageContext'
import { taCopy } from './taCopy'

const NAV = [
  { id: 'home', icon: Home },
  { id: 'schedule', icon: CalendarDays },
  { id: 'work', icon: ClipboardCheck },
  { id: 'me', icon: UserRound },
]

export function TaHeader({ name }) {
  const { language, toggleLanguage } = useLanguage()
  const copy = taCopy(language)
  const hour = new Date().getHours()
  const greeting = hour < 12
    ? copy('goodMorning')
    : hour < 18
      ? copy('goodAfternoon')
      : copy('goodEvening')
  return (
    <header className="ta-v2-header">
      <div>
        <p className="ta-v2-kicker"><span aria-hidden="true" />{copy('portal')}</p>
        <h1>{name ? `${greeting}, ${name}` : copy('portal')}</h1>
      </div>
      <button type="button" className="ta-v2-language lang-toggle" aria-label={copy('switchLanguage')} onClick={toggleLanguage}>
        <Globe2 aria-hidden="true" size={17} strokeWidth={1.8} />
        <span>{language === 'en' ? '中文' : 'EN'}</span>
      </button>
    </header>
  )
}

export function TaNavigation({ active, onChange }) {
  const { language } = useLanguage()
  const copy = taCopy(language)
  return (
    <nav className="ta-v2-nav" aria-label={copy('portal')}>
      {NAV.map(({ id, icon: Icon }) => (
        <button
          key={id}
          type="button"
          className={active === id ? 'is-active' : ''}
          aria-current={active === id ? 'page' : undefined}
          onClick={() => onChange(id)}
        >
          <Icon aria-hidden="true" size={19} strokeWidth={1.8} />
          <span>{copy(id)}</span>
        </button>
      ))}
    </nav>
  )
}

export function TaSubnav({ tabs, active, onChange, label, idPrefix, twoColumns = false }) {
  function handleKeyDown(event, index) {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return
    event.preventDefault()
    const nextIndex = event.key === 'Home'
      ? 0
      : event.key === 'End'
        ? tabs.length - 1
        : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length
    onChange(tabs[nextIndex].id)
    event.currentTarget.parentElement.querySelectorAll('[role="tab"]')[nextIndex]?.focus()
  }
  return (
    <div className={`ta-v2-subnav${twoColumns ? ' ta-v2-subnav-two' : ''}`} role="tablist" aria-label={label}>
      {tabs.map((tab, index) => <button
        key={tab.id}
        id={`${idPrefix}-tab-${tab.id}`}
        type="button"
        role="tab"
        tabIndex={active === tab.id ? 0 : -1}
        aria-selected={active === tab.id}
        aria-controls={`${idPrefix}-panel-${tab.id}`}
        className={active === tab.id ? 'is-active' : ''}
        onClick={() => onChange(tab.id)}
        onKeyDown={(event) => handleKeyDown(event, index)}
      >{tab.label}</button>)}
    </div>
  )
}

export function SectionUnavailable() {
  const { language } = useLanguage()
  return <p className="ta-v2-unavailable" role="status">{taCopy(language)('dataUnavailable')}</p>
}
